import { toast } from "react-toastify";
import Button from "react-bootstrap/Button";
import { DeleteIconCross } from "@/public/icons/icons";
import * as Sentry from '@sentry/browser';

// Custom close button used in toasts
const CloseButton = ({ closeToast }) => (
  <Button
    variant="link"
    className="closeButton d-flex pt-0 pe-0"
    style={{ height: "2rem" }}
    onClick={(e) => {
      e.stopPropagation();
      closeToast();
    }}
  >
    <DeleteIconCross width="18" height="18" color="#000" />
  </Button>
);

export function toast_Success(text) {
  toast.success(text, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    closeButton: CloseButton,
    style: {
      color: "black",
      backgroundColor: "#FFFFFF",
      border: "1px solid #5CB85C",
      borderLeft: "10px solid #5CB85C",
    },
  });
};

export function toast_Error(text) {
  toast.error(text, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    closeButton: CloseButton,
    style: {
      color: "black",
      backgroundColor: "#FFFFFF",
      border: "1px solid #D9534F",
      borderLeft: "10px solid #D9534F",
    },
  });

  Sentry.captureMessage(text);


};
